import loadable from "@loadable/component";
import { useState } from "react";
import { useParams } from "react-router";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import Spinner from "../../components/Reusable/Spinner";
import APIS from "../../constant/EndPoint";
import useGetHook from "../../customHooks/useGetHook";
import usePatchHook from "../../customHooks/usePatchHook";
import usePostHook from "../../customHooks/usePostHook";
import CreateIcon from "../../Icons/CreateIcon";
//@ts-ignore
import { usePDFPrintHook } from "@careinfo/layout";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

const EditDeliveryComponent = loadable(
  () => import("../../components/Delivery/EditDelivery")
);

const EditDelivery = () => {
  const { id } = useParams();
  const [searchParams, setSearchParms] = useSearchParams();
  const [defaultValue, setDefaultValue] = useState(null);
  const { data, refetch, isLoading } = useGetHook({
    queryKey: [`runsheet-${id}`],
    url: `${APIS.DELIVERY}${id}/`,
    params: {},
  });
  const { data: gridData, isLoading: isgridDataLoading } = useGetHook({
    queryKey: [`delivery-status`],
    url: `${APIS.DELIVERY_SETTING}`,
    params: {},
  });

  const { mutateAsync, isLoading: isPatchLoading } = usePatchHook({
    queryKey: [`runsheet-${id}`, "runsheet"],
    navigateURL: "",
  });

  const { mutateAsync: toggleMarkAsDone, isLoading: isMarkAsDoneLoading } =
    usePatchHook({
      queryKey: [`runsheet-${id}`, "runsheet"],
      navigateURL: "",
    });

  const { mutateAsync: attachConsignmentMutateAsync } = usePostHook({
    queryKey: ["runsheet-items"],
    navigateURL: "",
  });
  const { mutateAsync: checkConsignmentsMutateAsync } = usePostHook({
    queryKey: ["received-runsheet-items"],
  });

  const { mutateAsync: removeitems, isPostLoading: isRemoved } = usePostHook({
    queryKey: ["runsheet-items"],
    navigateURL: "",
  });
  const handleStatusChange = (data: any) => {
    setDefaultValue(data);
  };

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.DELIVERY}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };

  const handleToggleMarkAsDone = async (values: any, setError: any) => {
    const url = `${APIS.DELIVERY}${id}/toggle-is-active/`;
    let formData = {};
    try {
      await toggleMarkAsDone({ url, formData, setError });
      await refetch();
    } catch (err) {
      console.log(err);
    }
  };
  const handleAttachConsignment = async (
    consignmentId: string,
    statusId: any,
    setError: any
  ) => {
    const url = `${APIS.DELIVERY_ITEMS}`;
    let formData = {
      status_id: statusId,
      tracking_number: consignmentId,
      delivery: id,
    };

    try {
      await attachConsignmentMutateAsync({ url, formData, setError });
    } catch (err) {
      console.log(err);
    }
  };
  const handlecheckConsignments = async (consignmentId: string) => {
    const url = `${APIS.DELIVERY}${id}/receive-order/`;
    let formData = {
      tracking_number: consignmentId,
    };
    try {
      await checkConsignmentsMutateAsync({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  const { downloadPrint, isPrintLoading } = usePDFPrintHook();
  const handlePrint = async () => {
    const url = `${APIS.DELIVERY}${id}/print-pdf-delivery/`;
    let formData = {};
    try {
      const res = await downloadPrint(url, formData);
    } catch (err) {
      console.log(err);
    }
  };
  const handleRemove = async () => {
    const selectedOrder = searchParams.get("selectedItems")?.split(",");
    if (!selectedOrder?.length) {
      toast.error("Please select at least one order first");
      return;
    }
    const url = `${APIS.DELIVERY_ITEMS}remove-items/`;
    let formData = {
      items: selectedOrder,
    };
    try {
      const res = await removeitems({ url, formData });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Runsheet
        </span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditDeliveryComponent
          isLoading={isPatchLoading}
          data={data}
          gridData={gridData}
          handleEdit={handleEdit}
          handleAttachConsignment={handleAttachConsignment}
          handlePrint={handlePrint}
          isPrintLoading={isPrintLoading}
          handleToggleMarkAsDone={handleToggleMarkAsDone}
          handleRemove={handleRemove}
          isRemoved={isRemoved}
          handlecheckConsignments={handlecheckConsignments}
          handleStatusChange={handleStatusChange}
          defaultValue={defaultValue}
        />
      )}
    </>
  );
};
export default EditDelivery;
